import {
  type QueryKey,
  type UseMutationOptions,
  type UseMutationResult,
  useQuery as tanstack_useQuery,
} from "@tanstack/react-query"
import type { Omit } from "@wagmi/core/internal"
import { hashFn } from "@wagmi/core/query"
import { Evaluate } from "viem"
import type { UseQueryParameters, UseQueryReturnType } from "../types"

export function useQuery<queryFnData, error, data, queryKey extends QueryKey>(
  parameters: UseQueryParameters<queryFnData, error, data, queryKey> & {
    queryKey: QueryKey
  },
): UseQueryReturnType<data, error> {
  const result = tanstack_useQuery({
    ...(parameters as any),
    queryKeyHashFn: hashFn, // for bigint support
  }) as UseQueryReturnType<data, error>
  result.queryKey = parameters.queryKey
  return result
}

export type UseMutationParameters<
  data = unknown,
  error = Error,
  variables = void,
  context = unknown,
> = Evaluate<
  Omit<
    UseMutationOptions<data, error, Evaluate<variables>, context>,
    "mutationFn" | "mutationKey" | "throwOnError"
  >
>

export type UseMutationReturnType<
  data = unknown,
  error = Error,
  variables = void,
  context = unknown,
> = Evaluate<
  Omit<
    UseMutationResult<data, error, variables, context>,
    "mutate" | "mutateAsync"
  >
>
